import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const propTypes = {
  labelText: PropTypes.string.isRequired,
  hasError: PropTypes.bool.isRequired,
  leadText: PropTypes.string.isRequired
};
const defaultProps = {};

const LabelWrapper = styled.div`
  display: block;
  padding-bottom: 10px;
  width: 100%;
  text-align: left;
  ${props => `
    color: ${props.hasError && "red"}
  `};
`;

const LabelStandard = styled.label`
  font-weight: 400;
`;

const LabelLead = LabelStandard.extend`
  font-weight: 700;
  padding-right: 5px;
`;

function Label({ hasError, leadText, labelText }) {
  return (
    <LabelWrapper hasError={hasError}>
      <LabelLead>{leadText}</LabelLead>
      <LabelStandard>{labelText}</LabelStandard>
    </LabelWrapper>
  );
}

Label.propTypes = propTypes;
Label.defaultProps = defaultProps;

export default Label;



// WEBPACK FOOTER //
// ./src/components/Label/index.js